import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { ContactService } from 'src/app/services/contact/contact.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { ContactSupport } from 'src/app/utils/interfaces/new/contact-support.interface';
import { Header } from 'src/app/utils/interfaces/new/header.interface';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  motifs = [
    { id: "Je rencontre un problème d'utilisation du site", libelle: "Je rencontre un problème d'utilisation du site" },
    { id: "Je souhaite être recontacté par le support HyperMed", libelle: "Je souhaite être recontacté par le support HyperMed" },
    { id: "Autre", libelle: "Autre" },
  ]

  contactForm: FormGroup

  constructor(
    private _send: HeaderCommunicationService,
    private _builder: FormBuilder,
    private _modal: ModalService,
    private _device: DeviceDetectorService,
    private _view: ViewContainerRef,
    private _sendMail: ContactService,
    private _snakeBarSrv: SnackbarService,
  ) {
    const head: Header = {
      isHome: false,
      backPage: "home",
      isBack: true,
      title: "Contact support"
    };
    this._send.announceHeader(head);
  }

  ngOnInit(): void {
    this.contactForm = this._builder.group({
      motif: ['', Validators.required],
      message: ['', Validators.required]
    })
  }

  submit() {
    const loader = this._modal.openLoading(this._view);
    try {
      this.contactForm.markAllAsTouched();
      if (this.contactForm.valid) {
        const deviceInfo: DeviceInfo = this._device.getDeviceInfo();
        let technical = "Navigateur : " + deviceInfo.browser + ", Version du navigateur : " + deviceInfo.browser_version + ", Appareil : " + deviceInfo.deviceType + " " + deviceInfo.device + ", Système d'exploitation : " + deviceInfo.os + "(" + deviceInfo.os_version + "), Résolution : " + window.screen.width + "x" + window.screen.height;
        const contactSupport: ContactSupport = {
          motif: this.contactForm.get('motif').value,
          message: this.contactForm.get('message').value,
          technicalContext: technical
        };
        this._sendMail.send(contactSupport);
        this._modal.close(loader);
        this._snakeBarSrv.openSnackBar('Votre message a bien été envoyé.');        
      } else {
        this._modal.close(loader);
        this._snakeBarSrv.openSnackBar('Formulaire de contact non valide');
      }
    } catch (e) {
      this._modal.close(loader);
      this._snakeBarSrv.openSnackBar('Une erreur est survenue lors de l\'envoi.');
    }
  }
}
